export const telefoneFixoMask = '(00) 0000-0000';
export const telefoneCelularMask = '(00) 00000-0000';
export const cpfMask = '000.000.000-00';
export const cnpjMask = '00.000.000/0000-00';
export const cepMask = '00000-000';
export const ncmMask = '00000.00.00';
export const processoSeiMctiMask = '00000.000000/0000-00';
export const cnaeMask = '00.00-0-00';
